import React, {createContext, SetStateAction, useContext, useEffect, useState} from "react";

import {useTranslation} from "react-i18next";

import FetchHelper from "../components/Utils/helper";
import {OAuthContext} from "./OAuthContext";
import {EditorType, FilterListType} from "../components/Home/LeftFilter/type";
import {FetchErrorProps} from "./type";

type ApplicationsTableContextProps = {
    title: string
    setTitle: (title: string) => void
    // applicationsList: Array<FilterListType>
    // setApplicationsList: (lists: Array<FilterListType>) => void
    pendingApplicationsList: Array<FilterListType>
    setPendingApplicationsList: (lists: Array<FilterListType>) => void
    filteredLists: Array<FilterListType>
    setFilteredLists: (lists: Array<FilterListType>) => void
    editorsList: Array<EditorType>
    setEditorsList: (editors: Array<EditorType>) => void
    loadingApplications: boolean
    setLoadingApplications: (loading: boolean) => void
    activeIndex: number
    setActiveIndex: (idx: number) => void
    errorApplicationsTable: FetchErrorProps
    setErrorApplicationsTable: React.Dispatch<SetStateAction<FetchErrorProps>>
    inSyncList: Array<FilterListType>
    inInquiringList: Array<FilterListType>
}

type ApplicationsTableProviderProps = {
    children: React.ReactNode
}

export const ApplicationsTableContext = createContext<ApplicationsTableContextProps>({
    title: "", setTitle: () => {
    },
    // applicationsList: [], setApplicationsList: () => {},
    pendingApplicationsList: [], setPendingApplicationsList: () => {},
    filteredLists: [], setFilteredLists: () => {
    },editorsList: [], setEditorsList: () => {},
    loadingApplications: false, setLoadingApplications: () => {},
    activeIndex: 1, setActiveIndex: () => {},
    errorApplicationsTable: { error: false, message: ""},
    setErrorApplicationsTable: () => {},
    inSyncList: [],
    inInquiringList: []
});

export const ApplicationsTableProvider: React.FC<ApplicationsTableProviderProps> = ({children}) => {
    const {oauthData} = useContext(OAuthContext);
    const { t } = useTranslation('common');

    const [title, setTitle] = useState<string>(t("selection"));
    // const [applicationsList, setApplicationsList] = useState<Array<FilterListType>>([]);
    const [pendingApplicationsList, setPendingApplicationsList] = useState<Array<FilterListType>>([]);
    const [filteredLists, setFilteredLists] = useState<Array<FilterListType>>([]);
    const [editorsList, setEditorsList] = useState<Array<EditorType>>([])
    const [loadingApplications, setLoadingApplications] = useState<boolean>(false);
    const [activeIndex, setActiveIndex] = useState<number>(1);
    const [errorApplicationsTable, setErrorApplicationsTable] = useState<FetchErrorProps>({ error: false, message: "" })
    const [inSyncList, setInSyncList] = useState<Array<FilterListType>>([]);
    const [inInquiringList, setInInquiringList] = useState<Array<FilterListType>>([]);

    const getLists = React.useCallback(() => {
        const helper = new FetchHelper(oauthData?.token);
        helper.getEditorsList().then(res => {
            setEditorsList(res)
        }).catch(error => setErrorApplicationsTable(prevState => ({...prevState, error: true, message: error.message})))
        // helper.getApplications().then(res => setApplicationsList(res)).catch(error => setErrorApplicationsTable(prevState => ({...prevState, error: true, message: error.message})))
        helper.getApplicationByStatus("pending").then(res => {
            setPendingApplicationsList(res)
            setFilteredLists(res)
        }).catch(error => setErrorApplicationsTable(prevState => ({...prevState, error: true, message: error.message})))

        helper.getApplicationByStatus("in-sync").then(res => setInSyncList(res)).catch(error => setErrorApplicationsTable(prevState => ({...prevState, error: true, message: error.message})))
        helper.getApplicationByStatus("inquiring").then(res => setInInquiringList(res)).catch(error => setErrorApplicationsTable(prevState => ({...prevState, error: true, message: error.message})))

    }, [oauthData.token])

    useEffect(() => {
        if (oauthData.token.accessToken) {
            getLists()
        }
    }, [oauthData.token.accessToken, getLists])

    const defaultApplicationsTableContextValue = {title, setTitle, pendingApplicationsList, setPendingApplicationsList, filteredLists, setFilteredLists, editorsList, setEditorsList, loadingApplications, setLoadingApplications, activeIndex, setActiveIndex, errorApplicationsTable, setErrorApplicationsTable, inSyncList, inInquiringList};

    return <ApplicationsTableContext.Provider value={defaultApplicationsTableContextValue}>
        {children}
    </ApplicationsTableContext.Provider>
}